import React from 'react'
import { Space, Table, Tag,Modal} from 'antd';

function ClientModal({isModalOpen,setIsModalOpen,data,loading}) {
   console.log(isModalOpen)
    const columns = [
        {
          title: 'Client Id',
          dataIndex: 'client_id',
          key: 'client_id',
          render: (text) => <div>{text}</div>,
        },
        {
          title: 'Client Name',
          dataIndex: 'client_name',
          render: (text) => <div>{text}</div>,
        },
        {
          title: 'Total Case',
          dataIndex: 'total_case',
          key: 'total_case',
          render: (text) => <div>{text}</div>,
        },
       
      ];
   

    const handleCancel=()=>{
        setIsModalOpen(false)
    }
  return (
    <div>
    <Modal width={'80%'} title="Client Level Count"  open={isModalOpen} footer={false} onCancel={handleCancel}>
           <Table className='table-map-state' loading={loading} style={{marginTop:'30px'}}  scroll={{
                    y: 500,
                    x: 1000
                }}  columns={columns} dataSource={data} pagination={false} />
      </Modal>
    </div>
  )
}

export default ClientModal
